// same word for all languages due to the "unique" field type in the database

const userProfilesColors = {
  en: {
    black: "Black",
    red: "Red",
    orange: "Orange",
    yellow: "Yellow",
    green: "Green",
    blue: "Blue",
    indigo: "Indigo",
    purple: "Purple",
    pink: "Pink"
  },
  pt: {
    black: "Black",
    red: "Red",
    orange: "Orange",
    yellow: "Yellow",
    green: "Green",
    blue: "Blue",
    indigo: "Indigo",
    purple: "Purple",
    pink: "Pink"
  },
  es: {
    black: "Black",
    red: "Red",
    orange: "Orange",
    yellow: "Yellow",
    green: "Green",
    blue: "Blue",
    indigo: "Indigo",
    purple: "Purple",
    pink: "Pink"
  }
}

export default userProfilesColors
